import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch, useLocation } from "wouter";
import { useEffect } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Secrets from "./pages/Secrets";
import SecretDetail from "./pages/SecretDetail";
import IpAddresses from "./pages/IpAddresses";
import ProxyPass from "./pages/ProxyPass";
import ProxyDetail from "./pages/ProxyDetail";
import VirtualEnv from "./pages/VirtualEnv";
import VirtualEnvDetail from "./pages/VirtualEnvDetail";
import Docs from "./pages/Docs";
import Billing from "./pages/Billing";
import Pricing from "./pages/Pricing";
import Admin from "./pages/Admin";
import RenewToken from "./pages/RenewToken";
import Start from "./pages/Start";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Skills from "./pages/Skills";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookieConsent from "./components/CookieConsent";
import { captureMarketingAttribution } from "./lib/marketingAttribution";
import { applySeo } from "./lib/seo";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/secrets"} component={Secrets} />
      <Route path={"/secrets/:id"} component={SecretDetail} />
      <Route path={"/ip-addresses"} component={IpAddresses} />
      <Route path={"/proxy"} component={ProxyPass} />
      <Route path={"/proxy/:id"} component={ProxyDetail} />
      <Route path={"/virtual-env"} component={VirtualEnv} />
      <Route path={"/virtual-env/:id"} component={VirtualEnvDetail} />
      <Route path={"/docs"} component={Docs} />
      <Route path={"/pricing"} component={Pricing} />
      <Route path={"/blog/:slug"} component={BlogPost} />
      <Route path={"/blog"} component={Blog} />
      <Route path={"/skills"} component={Skills} />
      <Route path={"/privacy"} component={PrivacyPolicy} />
      <Route path={"/terms"} component={TermsOfService} />
      <Route path={"/start"} component={Start} />
      <Route path={"/auth/renew"} component={RenewToken} />
      <Route path={"/billing"} component={Billing} />
      <Route path={"/~internal/traction"} component={Admin} />
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const [location] = useLocation();

  useEffect(() => {
    applySeo(location);
  }, [location]);

  useEffect(() => {
    captureMarketingAttribution();
  }, [location]);

  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
          <CookieConsent />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
